export default defineAppConfig({});
